// 系统设置接口链接

// 基础路径判断
let protocol = window.location.protocol; // 协议
// 测试环境，域名的时候 http://cmms2.midea.com/
let baseApi = process.env.BASE_API;
if (window.location.href.indexOf('://cmms2') >= 0) {
  baseApi = 'http://cmms2.midea.com/';
}
if (protocol === 'https:') {
  baseApi = baseApi.replace('http:', 'https:');
}

/**
 * 字典管理
 */
// 页面初始化时获取字典列表
export const GET_DIC_LIST = '/cmms/common/dicList';
// 搜索字典列表
export const SEARCH_DIC_LIST = '/cmms/common/dic/search';
// 获取字典键值对列表
export const GET_DIC_VAL_LIST = '/cmms/common/dicValueList';
// 新增字典
export const ADD_DIC = '/cmms/common/dic/add';
// 修改字典
export const UPDATE_DIC = '/cmms/common/dic/update';
// 启用/禁用键值对
export const OP_KEY = '/cmms/common/opKey';
// 修改字典键值对
export const UPDATE_DIC_VAL = '/cmms/common/dicValue/update';
// 添加字典键值对
export const ADD_DIC_VAL = '/cmms/common/addKeyValue';

/**
 * 渠道管理
 */
// 查询渠道列表
export const CHANNEL_SITE_LIST = '/cmvip/channelSite/list';
// 新增渠道信息
export const CHANNEL_SITE_SAVE = '/cmvip/channelSite/save';
// 编辑渠道信息
export const CHANNEL_SITE_UPDATE = '/cmvip/channelSite/update';
// 删除渠道信息
export const CHANNEL_SITE_DELETE = '/cmvip/channelSite/delete';
/**
 * 快速通道
 */
// 获取应用列表
export const LIST_OF_ACCOUNT = '/cmms/app/listOfAccount';

/**
 * 会员店铺管理
 */
// 查询店铺列表
export const STORE_LIST_GET = '/cmvip/store/queryStore';
// 新增剔除店铺
export const STOP_STORE_ADD = '/cmvip/store/saveStopStore';
// 剔除店铺
export const STORE_DELETE = '/cmvip/store/deleteStore';
// 删除剔除店铺
export const STOP_STORE_DELETE = '/cmvip/store/deleteStopStore';
// 刷新店铺数据
export const STORE_UPDATE = '/cmvip/store/updateStore';
// 查询店铺刷新时间
export const STORE_UPDATE_TIME = '/cmvip/store/queryTime';
// 查询ECM平台
export const STORE_ECM_LIST = '/cmvip/store/queryEcmCode';
// 查询线下门店
export const OFFLINE_STORE_LIST = '/cmvip/store/queryCmdmStore';
// 积分线下门店导入
export const OFFLINE_STORE_UPLOAD = baseApi + '/cmvip/integralRuleApi/importTermstore';

// 查询黑名单操作列表
export const MEMBER_BLACK_LIST_RECORD = '/cmvip/blacklist/listRecord';

/**
 * 权限接口
 */
// 查询管理员所有权限菜单
export const AUTH_NEW_MENU_LIST_BY_USER = '/cmms/auth/newMenuListByUser';
// 新增组并分配权限
export const ACTIVITY_TEAM_ADD_NEW = '/cmms/activity/team/addNew';
// 查询新平台权限组
export const ACTIVITY_TEAM_NEW_LIST = '/cmms/activity/team/newList';
// 启用禁用组(启用)
export const ACTIVITY_TEAM_ENABLE = '/cmms/activity/team/enable';
// 启用禁用组(禁用)
export const ACTIVITY_TEAM_FORBIDDEN = '/cmms/activity/team/forbidden';
// 根据权限组id获取所属权限组列表
export const ACTIVITY_TEAM_USER_LIST = '/cmms/activity/team/userList';
// 删除所属权限组用户
export const ACTIVITY_TEAM_USER_DELETE = '/cmms/activity/teamUser/delete';
// 查询数据域菜单
export const AUTHORITY_LIST_ALL = '/cmms/authority/listAll';
// 回显数据域权限
export const AUTHORITY_LIST_BY_TEAM = '/cmms/authority/listByTeam';

/**
 * 管理员接口
 */
// 查询管理员列表
export const GET_USER_LIST = '/cmms/auth/getUserList';
// export const GET_USER_LIST = '/cmms/auth/getUserNewList';
// 获取权限组下拉选项
export const GET_TEAM_LIST = '/cmms/activity/team/newList';
// 获取权限信息
export const SELECT_NEW_MENU_LIST = '/cmms/auth/selectPermByTeam';
// 获取关联应用
export const GET_OPTIONAL_APP = '/cmms/auth/optionalApps';
// 新增管理员
export const ADD_NEW_USER = '/cmms/auth/user/addNew';
// 查询管理员详情
export const GET_USER_INFO = '/cmms/auth/getUserInfo';
// 禁用启用管理员（启用）
export const ENABLE_USER = '/cmms/auth/enableUser';
// 禁用启用管理员（禁用）
export const AUTH_FORBIDDEN_USER = '/cmms/auth/forbiddenUser';

/** 主体管理 */
// 获取主体列表
export const GET_ORG_LIST = '/cmms/org/list';
// 获取服务号列表
export const ORG_WXMP_LIST = '/cmms/org/wxmpList';
// 新增主体
// export const CMMS_ORG_ADD = '/cmms/org/add';
export const CMMS_ORG_ADD = '/cmms/org/saveNewOrg';
// 编辑主体
export const ORG_SAVE_ORG_WXMP = '/cmms/org/saveOrgWxmp';

/** 礼品管理 */
// 礼品列表
export const EXCHANGE_GOODS_THEIR_GOOOD_LIST = '/cmvip/exchangeGoods/theirGoodsList';
// 新增礼品
export const EXCHANGE_GOODS_ADD_THEIR_GOODS = '/cmvip/exchangeGoods/addTheirGoods';
// 更新礼品状态
export const EXCHANGE_GOODS_UPDATE_THEIR_GOODS_STATUS = '/cmvip/exchangeGoods/updateTheirGoodsStatus';
// 礼品详情
export const EXCHANGE_GOODS_THEIR_GOODS_DETAIL = '/cmvip/exchangeGoods/theirGoodsDetail';
// 编辑礼品
export const EXCHANGE_GOODS_UPDATE_THEIR_GOODS = '/cmvip/exchangeGoods/updateTheirGoods';
// 礼品管理——同步
export const EXCHANGE_GOODS_SYNC_THEIR_GOODS = '/cmvip/exchangeGoods/syncJdGoods';

// 修改手机号
export const USER_API_DELETE_AEW_USER_CHANGE_OLD_USER = '/ccrm2-core/userApi/deleteNewUserChangeOldUser';
// 注销用户手机号
export const USER_API_USER_LOG_OFF = '/ccrm2-core/userApi/userLogoff';

/** 积分规则调用 */
// 积分规则调用方列表
export const POINT_RULE_CALLER_GET_PAGE_LIST = '/cmvip/pointRuleCaller/getPageList';
// 新增/修改积分规则调用方
export const POINT_RULE_CALLER_INSERT_OR_UPDATE = '/cmvip/pointRuleCaller/insertOrUpdate';

/** 敏感词管理 */
// 敏感词管理列表
export const SENSITIVE_GET_SENSITIVE_WORDS = '/cmms/sensitive/getSensitiveWords';
// 新增敏感词汇
export const SENSITIVE_ADD = '/cmms/sensitive/add';
// 编辑敏感词汇
export const SENSITIVE_EDIT = '/cmms/sensitive/edit';
// 单个删除敏感词汇
export const SENSITIVE_DELETE_BY_ID = '/cmms/sensitive/deleteById';
// 批量删除敏感词汇
export const SENSITIVE_BATCH_DELETE_BY_IDS = '/cmms/sensitive/batchDeleteByIds';
// 批量导入
export const SENSITIVE_BATCH_INSERT = baseApi + 'cmms/sensitive/batchInsert';
// 导出敏感词汇
export const SENSITIVE_EXPORT = baseApi + 'cmms/sensitive/export';
